import { useQuery } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export function useAtmQuery(atmId: number) {
  return useQuery({
    queryKey: ["atm", atmId],
    enabled: !!atmId,
    queryFn: async () => {
      const response = await BankMpProvider.getAtmList(atmId);

      console.log({ response });

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.error?.message);
      }

      return response.data;
    },
    select: (data) => ({
      ...data,
      fee: {
        withdrawFeePercent: data.commission.commissions.withdraw.commission,
        transferFeePercent: data.commission.commissions.transfer.commission,
        depositFeePercent: data.commission.commissions.deposit.commission,
      },
    }),
  });
}
